import React from "react";
import { PropTypes } from "prop-types";
import { NumericRatingScaleRadioButton } from "./NumericRatingScaleRadioButton";
import { TextWithLineBreaks } from "../TextWithLineBreaks/TextWithLineBreaks";

import "./NumericRatingScale.css";

export function NumericRatingScale({
  anchorLabelStart,
  anchorLabelEnd,
  ariaDescribedBy,
  ariaLabelledBy,
  choices,
  id,
  onChange,
  readOnly = false,
  valid = true,
  value,
}) {
  function renderChoice({ label, value: choiceValue }, index) {
    const isFirstChoice = index === 0;
    const isLastChoice = index === choices.length - 1;
    const showIndicatorArrow =
      (isFirstChoice && !!anchorLabelStart) || (isLastChoice && !!anchorLabelEnd);
    const isSelected = String(value) === String(choiceValue);

    return (
      <NumericRatingScaleRadioButton
        ariaDescribedBy={ariaDescribedBy}
        checked={isSelected}
        disabled={readOnly && !isSelected}
        key={choiceValue}
        label={label}
        name={id}
        onChange={onChange}
        showIndicatorArrow={showIndicatorArrow}
        value={choiceValue}
        valid={valid}
      />
    );
  }

  return (
    <div
      id={id}
      className="numeric-rating-scale"
      role="radiogroup"
      aria-labelledby={ariaLabelledBy}
    >
      {anchorLabelStart && (
        <span className="numeric-rating-scale__anchor-label-start">
          <TextWithLineBreaks text={anchorLabelStart} />
        </span>
      )}
      {anchorLabelEnd && (
        <span className="numeric-rating-scale__anchor-label-end">
          <TextWithLineBreaks text={anchorLabelEnd} />
        </span>
      )}
      <div className="numeric-rating-scale__choices">
        {choices.map(renderChoice)}
      </div>
    </div>
  );
}

NumericRatingScale.propTypes = {
  anchorLabelStart: PropTypes.string,
  anchorLabelEnd: PropTypes.string,
  ariaDescribedBy: PropTypes.string,
  ariaLabelledBy: PropTypes.string,
  choices: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    })
  ),
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  valid: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
